import React, { useContext, useEffect, useRef, useState } from "react";
import { Sorting } from "../../../../components/Lists/Sorting";
import Skeleton from "react-loading-skeleton";
import { ResultsNotFound } from "../../../../components/ResultsNotFound/ResultsNotFound";
import { Tooltip } from "@mui/material";
import "./OrderListDetails.css";
import { Expandable } from "../../../../components/Expandable/Expandable";
import OrderDetailInfo from "./OrderDetailInfo";
import { DropdownsProvider } from "../../../../contexts/DropdownsContext";
import { NewOrderContext } from "../../context/NewOrderContext";
import { use } from "react";
import { getCurrencySymbol } from "../../../../utils/utils";
const OrderListDetails = ({
  parts,
  fromQuote,
  quoteToOrderList,
  vendorParentId,
}) => {
  const getSortingOrder = (order) => {};
  const listRef = useRef(null);
  const propertyRefs = useRef({});
  const [tooltips, setTooltips] = useState({});
  const [loadingParts, setLoadingParts] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [openStates, setOpenStates] = useState({});

  const {
    lineNumberInfo,
    vendorLineNumberInfoList,
    generalInfo,
    setCountDetails,
  } = useContext(NewOrderContext);
  const handleScroll = (event) => {
    const { scrollTop, clientHeight, scrollHeight } = event.currentTarget;
    if (scrollHeight - (scrollTop + 3) <= clientHeight) {
      //if (!setLoadingPartsReq) requestNextPage();
    }
  };
  useEffect(() => {
    const newTooltips = {};
    Object.entries(propertyRefs.current).forEach(([key, el]) => {
      if (el) {
        newTooltips[key] = el.scrollWidth > el.clientWidth;
      }
    });
    setTooltips(newTooltips);
    if (!fromQuote) {
      const dataProcessed = proccessPartsData();
      setDataList(dataProcessed);
      setCountDetails(dataProcessed.length);
    } else {
      const dataProcessed = proccessQuoteData();
      setDataList(dataProcessed);
      setCountDetails(dataProcessed.length);
    }
  }, []);
  useEffect(() => {
    if (!lineNumberInfo) return;
    const matchingLineInfo = fromQuote
      ? vendorLineNumberInfoList?.find(
          (entry) => entry.vendorParentId === vendorParentId
        )
      : null;
    

    setDataList((prevList) =>
      prevList.map((item) => {
        const lineNumber = fromQuote
          ? matchingLineInfo?.lineNumberInfo?.[item.line_number]
          : lineNumberInfo?.[item.line_number];

        const info = lineNumber;
        if (!info) return item;

        return {
          ...item,
          part_condition: info.partConditionName ?? "New",
          quantity_order: info.orderQty ?? 0,
          unit_cost: info.unitCost ?? 0,
          total: info.totalCost ?? 0,
          est_delivery_date: info.estDeliveryDate ?? "--",
        };
      })
    );
  }, [vendorLineNumberInfoList, lineNumberInfo]);
  const proccessPartsData = () => {
    if (parts && parts.length > 0) {
      const grouped = parts.reduce((acc, item) => {
        const key = item.part_id;

        if (!acc[key]) {
          acc[key] = {
            part_number: item.part_number,
            id: item.part_id,
            part_description: item.part_description,
            prn_info: [],
            part_condition: "New",
            uom_abrevation: item.uom_abrevation,
            uom_id: item.uom_id,
            quantity_order: "0",
            unit_cost: "0",
            total: "0",
            est_delivery_date: "--",
            company_id: item.company_id,
          };
        }

        acc[key].prn_info.push({
          prn_id: item.id,
          wp: item.work_package_id,
          work_package_number: item.work_package_number,
          tc_fnd: item.reference_id,
          task_card_number: item.task_card_number,
          tail_number: item.tail_number,
          quantity_required: item.remaining_quantity,
        });

        return acc;
      }, {});

      return Object.values(grouped).map((group, index) => ({
        ...group,
        quantity_order: group.prn_info
          .map((prn) => prn.quantity_required)
          .reduce((a, b) => a + b, 0),
        prn_count: group.prn_info.length,
        line_number: index + 1,
      }));
    }
  };
  const proccessQuoteData = () => {
    if (quoteToOrderList && quoteToOrderList.length > 0) {
      const grouped = quoteToOrderList.reduce((acc, item) => {
        const key = item.part_id;

        const today = new Date();
        const est_delivery_date = new Date(today);
        est_delivery_date.setDate(today.getDate() + item.lead_days);

        if (!acc[key]) {
          acc[key] = {
            part_number: item.part_number,
            id: item.part_id,
            part_description: item.part_description,
            prn_info: [],
            part_condition: "New",
            uom_abrevation: item.uom_abrevation,
            uom_id: item.uom_id,
            quantity_order: item.quantity_required,
            unit_cost: item.unit_cost,
            discount_applied: item.discount_applied,
            tax_included: item.tax_included,
            total: item.total_cost,
            est_delivery_date: est_delivery_date.toISOString().split("T")[0],
            company_id: item.company_id,
            quote_id: item.id,
          };
        }

        acc[key].prn_info.push({
          prn_id: item.part_request_id,
          wp: item.work_package_id,
          work_package_number: item.work_package_number,
          tc_fnd: item.reference_id,
          task_card_number: item.reference_number,
          tail_number: item.tail_number,
          quantity_required: item.quantity_required,
        });

        return acc;
      }, {});

      return Object.values(grouped).map((group, index) => ({
        ...group,
        quantity_order: group.prn_info
          .map((prn) => prn.quantity_required)
          .reduce((a, b) => a + b, 0),
        prn_count: group.prn_info.length,
        line_number: index + 1,
      }));
    }
  };
  //Expandable

  const toggleOpenState = (aircraftId, open) => {
    closeAllOpenStates();
    setTimeout(() => {
      setOpenStates((prevState) => ({
        ...prevState,
        [aircraftId]: open,
      }));
    }, 100);
  };
  const closeAllOpenStates = () => {
    setOpenStates((prevState) => {
      const newState = {};
      Object.keys(prevState).forEach((key) => {
        newState[key] = false;
      });
      return newState;
    });
  };
  const renderCell = (item, label, idx, propertyRefs, tooltips) => {
    const refCallback = (el) => {
      if (el) {
        propertyRefs.current[`${item.id}-${label}`] = el;
      }
    };

    const tooltipTitle = tooltips[`${item.id}-${label}`] ? item[label] : "";

    const content = (() => {
      switch (label) {
        case "prn_count":
          return (
            <div className="prn-container-count">
              <p className="light-font" ref={refCallback}>
                {item[label]}
              </p>
            </div>
          );
        case "part_condition":
          return (
            <p className="bold-font" ref={refCallback}>
              {item[label]}
            </p>
          );
        case "est_delivery_date":
          return (
            <p className="light-right-font" ref={refCallback}>
              {item[label]}
            </p>
          );
        case "unit_cost":
        case "total":
          return (
            <p
              className={label === "unit_cost" ? "bold-font-blue" : "bold-font"}
              ref={refCallback}
            >
              {/* {generalInfo?.currencyName && getCurrencySymbol(generalInfo?.currencyName)} */}
              {new Intl.NumberFormat("en-US", {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
              }).format(item[label])}{" "}
              {generalInfo?.currencyName ?? "--"}
            </p>
          );
        case "quantity_order":
          return (
            <p className="light-font" ref={refCallback}>
              {item[label]} {item.uom_abrevation}
            </p>
          );
        default:
          return (
            <p className="light-font" ref={refCallback}>
              {item[label]}
            </p>
          );
      }
    })();

    return (
      <div className="property" key={label}>
        {label === "reference_id" && (
          <i className="icon-task_icon_partRequest"></i>
        )}
        <Tooltip title={tooltipTitle} arrow>
          {content}
        </Tooltip>
      </div>
    );
  };
  const renderSummary = (item, idx, propertyRefs, tooltips) => (
    <div className="item-new-order-container">
      <div className="property">
        <div className="generation-tag">--</div>
      </div>
      <div className="property">
        <p className="light-font">{idx + 1}</p>
      </div>
      {[
        "part_number",
        "part_description",
        "prn_count",
        "part_condition",
        "quantity_order",
        "unit_cost",
        "total",
        "est_delivery_date",
      ].map((label) => renderCell(item, label, idx, propertyRefs, tooltips))}
    </div>
  );
  return (
    <>
      <b className="title-order-detail">Details</b>
      <div className="sorting-header">
        <Sorting
          onOrderChange={getSortingOrder}
          ignoreProperties={true}
        showHeaderOrder={true}
          displayButton={false}
          hideArrows={true}
          properties={{
            status: "Status",
            ln: "LN",
            PN: "PN",
            issued: "Description",
            remaining: "PRN Info.",
            available: "Part Condition",
            pendingOrder: "Order QTY",
            pendingTransfer: "Unit Cost",
            otherLocationsAVL: "Total",
          }}
        />
        <b className="last-column">Est Delivery Date</b>
      </div>

      <div className="order-details-list" ref={listRef} onScroll={handleScroll}>
        {loadingParts ? (
          Array.from({ length: 7 }).map((_, idx) => (
            <div key={idx} className="item-container-skeleton">
              <Skeleton
                style={{ borderRadius: "10px" }}
                height="1.68rem"
                width={40}
              />
              <div className="item-skeleton-content">
                <Skeleton height={20} width="80%" />
              </div>
              <Skeleton height={30} width="7rem" />
            </div>
          ))
        ) : dataList.length === 0 ? (
          <ResultsNotFound />
        ) : (
          dataList.map((item, idx) => (
            <Expandable
              key={`${item?.id}-${idx}`}
              name={`${item?.id}-type-configuration-${idx}`}
              summary={renderSummary(item, idx, propertyRefs, tooltips)}
              isOpen={openStates[item?.id]}
              onToggle={(open) => toggleOpenState(item?.id, open)}
            >
              {openStates[item?.id] && (
                <DropdownsProvider>
                  <OrderDetailInfo
                    item={item}
                    fromQuote={fromQuote}
                    vendorParentId={vendorParentId}
                    onChangeItem={() => {}}
                  />
                </DropdownsProvider>
              )}
            </Expandable>
          ))
        )}
      </div>
    </>
  );
};
export default OrderListDetails;
